import { render, staticRenderFns } from "./BaseProductColorConfigurationItem.vue?vue&type=template&id=65517172&scoped=true"
import script from "./BaseProductColorConfigurationItem.vue?vue&type=script&lang=js"
export * from "./BaseProductColorConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./BaseProductColorConfigurationItem.vue?vue&type=style&index=0&id=65517172&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65517172",
  null
  
)

export default component.exports